import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {LoginService} from '@shared/services/login.service';

@Component({
  selector: 'si-faq-icon',
  templateUrl: './faq-icon.component.html',
  styleUrls: ['./faq-icon.component.scss']
})
export class FaqIconComponent {
  language: string;

  constructor(
    private router: Router,
    private loginService: LoginService
  ) { }

  onClickButtonFAQ(): void {
    if (this.loginService.getSession()) {
      this.router.navigate(['/faqs']);
    } else {
      this.router.navigate(['/lfaqs']);
    }
  }
}
